<template lang="pug">
    .communities-search(v-if="isIntialized")
        .communities-search__top
            .communities-search__top-left
                h2.communities-search__heading {{ headerText }}
                .communities-search__clear-container
                    .communities-search__search-container
                        input.communities-search__input(:placeholder="searchFieldWatermark" v-model="currentQuery" @keyup.enter="setQuery( currentQuery )" )  
                        .communities-search__search-icon(@click="setQuery( currentQuery )")
                            svg(width='23px' height='23px' viewbox='0 0 23 23' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink')
                                g#Comps(stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round')
                                    g(id='Desktop-/-Blog' transform='translate(-1602.000000, -1405.000000)' stroke='#FFFFFF' stroke-width='2')
                                        g#search(transform='translate(1604.000000, 1407.000000)')
                                            path#Path(d='M2.2294743,9.38745316 C2.2294743,13.3406957 5.43421056,16.5454319 9.38745308,16.5454319 C13.3406956,16.5454319 16.5454319,13.3406957 16.5454319,9.38745316 C16.5454319,6.83015362 15.1811289,4.46711139 12.9664425,3.18846161 C10.7517561,1.90981183 8.02315001,1.90981183 5.80846366,3.18846161 C3.5937773,4.46711139 2.2294743,6.83015362 2.2294743,9.38745316 Z' transform='translate(9.387453, 9.387453) rotate(-23.025000) translate(-9.387453, -9.387453) ')
                                            line#Path(x1='14.4484792' y1='14.4484005' x2='20' y2='20.0007111')
                    .communities-search__search-validation(v-if='validQuery == false') Please Enter a Search Term
                    .communities-search__clear-search(@click="clearSearch()") Clear Search
                .communities-search__filters-container
                    .communities-search__filters-group(v-for='filter in searchFilters')
                        p.communities-search__filter-label {{ filter.label }}
                        .communities-search__filters
                            .communities-search__filter(v-for='value in filter.values')
                                input(type="checkbox" :value='value.id' @change="setFilters([filter.id,value.id])")
                                label(:for='value.id') {{ value.label }}
    
            .communities-search__top-right
                img.communities-search__image(:src="currentFilterImage" width="350" height="250")
        .communities-search__bottom
            .communities-search__content
                Transition
                    .communities-search__loading(v-if="isLoading")
                        Loader
                    .g.g-centered(v-else-if="!isError")
                        template(v-if='communities.length === 0')
                            .communities-search__no-results No results. Try Searching Again!
                        template(v-else)
                            h3.g__c.g__c--md12(v-if="!searchQuery && currentTypes.length < 1 && currentLocations.length < 1") Featured Communities
                            a.g__c.g__c--md3.communities-search__community(v-for='community in communities' :href="community.url")
                                img.communities-search__community-image(:src="community.image" width="350" height="250") 
                                .communities-search__community-copy
                                    .communities-search__community-name {{ community.name }}
                                    .communities-search__community-address {{ community.address }}
                                    .communities-search__community-cta
                                        img(src='/img/template-images/arrow-corner-right-2.svg')
    
                    .communities-search__error-state(v-else="isError")
                        h2 There has been an error, please reload and try again. 
    div(v-else)
        Loader
    </template>
        
    <script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import Loader from './components/loader'
    
    export default {
        name: "CommunitiesListing",
        components: {
            Loader
        },
        data() {
            return {
                api: this.$root.api,
                searchFilters: [],
                currentQuery: '',
                indexName: this.$root.indexName,
            }
        },
        computed: {
            ...mapState({
                isLoading: state => state.isLoading,
                isIntialized: state => state.isIntialized,
                isError: state => state.isError,
                filters: state => state.filters,
                communities: state => state.communities,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                currentFilters: state => state.currentFilters,
                searchQuery: state => state.searchQuery,
                validQuery: state => state.validQuery,
                currentFilterImage: state => state.filterImage,
                currentTypes: state => state.currentTypes,
                currentLocations: state => state.currentLocations,
                headerText: state => state.headerText,
                searchFieldWatermark: state => state.searchFieldWatermark,
            }),
            payload() {
                let page = this.currentPage
                let query = this.searchQuery
                let location = ''
                let type = this.currentFilters
                return { page, query, location, type }
            },
            clearActive(){
                let contentSelected = this.currentQuery != '' || this.currentTypes.length > 0 || this.currentLocations.length > 0 ? true : false
                return contentSelected
            }
        },
        methods: {
            ...mapActions(['getData', 'setFilters', 'setQuery']),
            ...mapMutations(['setCurrentFilters', 'setCurrentPage', 'setApi', 'setIndexName', 'setFilterImage', 'setHeaderText', 'setSearchFieldWatermark', 'clearCurrentFilters',]),
    
            async clearSearch() {
                var checkboxes = document.querySelectorAll('input[type="checkbox"]');
                for (var checkbox of checkboxes) {
                    checkbox.checked = this.checked;
                }
                this.currentQuery = ''
                this.clearCurrentFilters()
    
                let page = 1
                let query = ''
                let location = ''
                let type = []
                let cleanPayload = { page, query, location, type }
                this.setApi(this.$root.api)
    
                await this.getData(cleanPayload)
            }
        },
        watch: {
        },
        async created() {
            this.setApi(this.$root.api)
            this.setIndexName(this.$root.indexName)
    
            this.setFilterImage(this.$root.filterImage)
            this.setHeaderText(this.$root.headerText)
            this.setSearchFieldWatermark(this.$root.searchFieldWatermark)
            await this.getData(this.payload)
            this.searchFilters = this.filters
    
        }
    }
    </script>
        
    <style scoped lang="scss">
    .communities-search {
        &__no-results {
            text-align: center;
            width: auto;
            margin: auto;
        }
    
        &__clear-container {
            width: 100%;
        }
    
        &__clear-search {
            margin-top: 0;
            text-decoration: underline;
            text-transform: uppercase;
            font-weight: bold;
            font-family: $fontFamilyHeadings;
            cursor: pointer;
            width: 155px;
            &.isActive{
                display: flex;
    
            }
    
        }
    
        .btn {
            height: 2em;
            margin: 1em 0;
    
            @include mqdn(md) {
                width: 100%
            }
        }
    
        &__top {
            display: flex;
            background-color: $lightGray;
            align-items: center;
    
            &-left {
                width: 50%;
                padding: 3em;
    
            }
    
            &-right {
                width: 50%;
                overflow: hidden;
    
                img {
                    width: 100%;
                    height: 100%;
                    -o-object-fit: cover;
                    object-fit: cover;
                    aspect-ratio: 1/1;
    
                    @include mqdn(md) {
                        aspect-ratio: 2/1;
                    }
                }
            }
    
            @include mqdn(md) {
                flex-direction: column-reverse;
    
                &-left {
                    width: 100%;
                    padding: 1em;
    
                }
    
                &-right {
                    width: 100%;
    
                    img {
                        width: 100%;
                    }
                }
            }
    
        }
    
        &__heading {
            font-weight: bold;
            font-family: $fontFamilyHeadings;
            text-transform: uppercase;
            margin: 0;
        }
    
        &__search-container {
            border: 1px solid $corpBlue;
            border-radius: 3px;
            display: flex;
            margin: 1em 0;
            background: $white;
            width: auto;
            flex: 1;
        }
    
        &__search-validation {
            color: $coral
        }
    
        &__input {
            width: 100%;
            border: none;
            padding: 0;
            background: white;
            padding-left: 0.25em;
    
            .search-field {
                width: 100%;
                padding: 5px 15px;
                border: none;
            }
    
        }
    
        &__search-icon {
            cursor: pointer;
            background-color: $corpBlue;
            padding: 5px;
        }
    
        &__filters-container {
            line-height: normal;
        }
    
        &__filters {
            display: flex;
            flex-wrap: wrap;
    
    
            &-group {
                &:first-child {
                    grid-area: 1 / 1 / 2 / 2;
                }
    
                &:last-child {
                    grid-area: 1 / 2 / 2 / 4;
                }
            }
        }
    
        &__filter-label {
            font-weight: bold;
            font-family: $fontFamilyHeadings;
            text-transform: uppercase;
            margin-top: 1em;
            margin-bottom: 0.5em;
        }
    
        &__filter {
            font-family: $fontFamilyHeadings;
            text-transform: uppercase;
            margin-bottom: .5em;
            display: flex;
            gap: 5px;
            align-items: center;
            margin-right: 1em;
    
            input[type="checkbox"] {
                margin-right: .5em;
                appearance: none;
                background-color: transparent;
                margin: 0;
                color: currentColor;
                width: 1em;
                height: 1em;
                border: 1px solid $black;
                display: grid;
                place-content: center;
    
                &:before {
                    content: "";
                    background-color: $brightBlue;
                    width: 0.65em;
                    height: 0.65em;
                    transform: scale(0);
                    transition: 120ms transform ease-in-out;
                    box-shadow: inset 1em 1em var(--form-control-color);
                    transform-origin: bottom left;
                    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
                }
    
                &:checked {
                    background-color: $white;
    
                    &:before {
                        transform: scale(1);
                    }
                }
            }
    
    
        }
    
        &__bottom {
            margin: 3em 0;
        }
    
        &__loading {
            text-align: center;
        }
    
        &__community {
            background: $lightGray;
            box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
            cursor: pointer;
    
            a {
                display: flex;
                flex-flow: column;
                height: 100%;
            }
    
            &:hover {
                transform: scale(1.025);
                transition: transform cubic-bezier(0.39, 0.575, 0.565, 1) 0.25s;
                text-decoration: none !important;
    
                *,
                .article-card__text,
                .article-card__tags,
                .article-card__title {
                    text-decoration: none !important;
                }
            }
    
            &-image {
                width: 100%;
                height: auto;
    
            }
    
            &-copy {
                font-family: $fontFamilyHeadings;
                font-weight: bold;
                padding: 1em;
                flex: 1 1 auto;
                display: grid;
            }
    
            &-name {
                color: $lightBlue;
                margin-bottom: 0.25em;
                text-transform: uppercase;
            }
    
            &-address {
                color: $corpBlue;
            }
    
            &-cta {
                color: $coral;
                margin-top: 10px;
                text-align: end;
                align-self: flex-end;
                justify-self: end;
            }
    
        }
    
        &__pagination_numbers {
            display: flex;
        }
    
        &__pagination {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 1em;
    
            &-number {
                cursor: pointer;
                font-weight: bold;
                font-family: $fontFamilyHeadings;
                text-transform: uppercase;
                padding: 0 1em;
    
                &[data-current] {
                    color: $brightBlue;
                }
            }
        }
    
    }</style>